// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"food-menu-module--wrapper--1x68A","innerWrapper":"food-menu-module--innerWrapper--1JRoM"};